import {CLOSE_MODAL, OPEN_MODAL} from './modalTypes';
const initialState = {
   open: false,
   mostrarBotonesAccion: false,
   children: null
};

function modalReducer(state = initialState, action) {
   switch (action.type) {
      case OPEN_MODAL:
         return {...state, open: true, ...action.payload};
      case CLOSE_MODAL:
         return initialState;
      default:
         return state;
   }
}

export default modalReducer;
